/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['body{overflow:visible}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRTovRGV2ZWxvcG1lbnQvQUsvYmItY29kZS9CQi5XZWIvYXBwL2NvbXBvbmVudHMvYXBpLWRvY3VtZW50YXRpb24vYXBpLWRvY3VtZW50YXRpb24uY29tcG9uZW50LnNjc3MubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL0U6L0RldmVsb3BtZW50L0FLL2JiLWNvZGUvQkIuV2ViL2FwcC9jb21wb25lbnRzL2FwaS1kb2N1bWVudGF0aW9uL2FwaS1kb2N1bWVudGF0aW9uLmNvbXBvbmVudC5zY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./compiled/app/components/api-documentation/api-documentation.component.scss.ngstyle.ts